module.exports = __webpack_public_path__ + "img/milestone__03.67330032.jpg";